import axios, { AxiosPromise } from 'axios';

const zalozeniSRDApi = (isin: string): AxiosPromise<{ id: number }> => {
    return axios({
        method: 'POST',
        url: 'SRD/Zalozeni',
        data: {
            isin
        }
    });
};
export default zalozeniSRDApi;
